import { cn } from "@/utils/helpers";
import type { MarketSignal } from "@/types/marketSignal.type";

/**
 * "{n} sources" as a text button that opens the sources dialog, for the places
 * that name a signal's evidence without printing it (steering rows, history
 * detail). Only observations open: a signal grounded in Brand DNA facts alone
 * says so in muted text, and one with nothing behind it says that.
 */
export default function SignalEvidenceSources({
  signal,
  onOpenSources,
  className,
}: {
  signal: MarketSignal;
  onOpenSources: () => void;
  className?: string;
}) {
  const n = signal.groundingObservations.length;
  const facts = signal.groundingFactIds.length;

  if (n === 0) {
    return (
      <span className={cn("sig-sources is-muted", className)}>
        {facts > 0 ? `${facts} Brand DNA ${facts === 1 ? "fact" : "facts"}` : "No sources"}
      </span>
    );
  }

  return (
    <button
      type="button"
      className={cn("sig-sources", className)}
      aria-haspopup="dialog"
      aria-label={`${n} ${n === 1 ? "source" : "sources"} for ${signal.title}`}
      onClick={onOpenSources}
    >
      {n} {n === 1 ? "source" : "sources"}
    </button>
  );
}
